module.exports = __webpack_public_path__ + "img/LsgAudio24-27.6df87e1c.jpeg";